import SectionMessage from '@atlaskit/section-message';
import React, { FC } from 'react';

import ExternalLinkAction from '@/components/primitive/external-link';
import { DAC_SLO_LOW_PRIORITY_LINK } from '@/constants';

type LowPriorityWarningProps = {
  isLowPriority: boolean;
};

const LowPriorityWarning: FC<LowPriorityWarningProps> = props => {
  const { isLowPriority } = props;

  return (
    <>
      {isLowPriority && (
        <SectionMessage
          appearance="warning"
          title="SLO is low priority"
          testId="slo-priority-warning"
        >
          This SLO has been marked as low priority, this means that the timeseries data for this SLO
          will be collected less frequently, thus data visible on this page may be out of date. To
          fix this, please resolve any HIGH severity quality score results associated with this SLO.
          {` `}
          <ExternalLinkAction text="Find out more." href={DAC_SLO_LOW_PRIORITY_LINK} />
        </SectionMessage>
      )}
    </>
  );
};
export default LowPriorityWarning;
